import { render, staticRenderFns } from "./TreatmentDirectoryPreview.vue?vue&type=template&id=629a28e3&scoped=true"
import script from "./TreatmentDirectoryPreview.vue?vue&type=script&lang=js"
export * from "./TreatmentDirectoryPreview.vue?vue&type=script&lang=js"
import style0 from "./TreatmentDirectoryPreview.vue?vue&type=style&index=0&id=629a28e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629a28e3",
  null
  
)

export default component.exports